import * as React from 'react';

// Component
import { GenericPopup } from '@shopee-user/shared-customization-ui';

// Icons
import IconDialogError from '../Icons/iconDialogError';
import IconDialogWarning from '../Icons/iconDialogWarning';

// Utils
import cx from 'classnames';

// Types
import {
  DialogProps,
  DialogLevel,
} from '@shopee-user/business-customization-types';

// Styles
import styles from './styles.scss';

const ICON_MAPPING: {
  [key in DialogLevel]: React.ComponentType<{ className: string }>;
} = {
  error: IconDialogError,
  warning: IconDialogWarning,
};

const Dialog = ({
  shouldShow,
  level,
  title,
  content,
  primaryActionText,
  secondaryActionText,
  onClickPrimary,
  onClickSecondary,
  disablePrimary,
  disableSecondary,
  hideSecondary,
  contentClassName,
  containerClassName,
  onClose,
  contentRef,
}: DialogProps) => {
  const Icon: React.ComponentType<{ className: string }> | undefined = level
    ? ICON_MAPPING[level]
    : undefined;

  return (
    <GenericPopup
      showOverlay={true}
      overlayStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.60)' }}
      shouldShow={shouldShow}
      onClose={onClose}
    >
      <div className={cx(styles.container, containerClassName)}>
        <div className={styles.titleAndContentContainer}>
          {Icon && <Icon className={styles.icon} />}
          {title && (
            <div
              className={cx(styles.title, {
                [styles.titleNoIcon]: !Icon,
                [styles.titleNoContent]: !content,
              })}
            >
              {title}
            </div>
          )}
          {content && (
            <div
              className={cx(styles.content, contentClassName, {
                [styles.contentNoIcon]: !Icon,
                [styles.contentNoTitle]: !title,
              })}
              ref={contentRef}
            >
              {content}
            </div>
          )}
        </div>

        <div className={styles.buttonContainer}>
          {!hideSecondary && (
            <div
              onClick={!disableSecondary ? onClickSecondary : undefined}
              className={cx(styles.button, {
                [styles.buttonDisabled]: disableSecondary,
              })}
            >
              {secondaryActionText}
            </div>
          )}
          <div
            onClick={!disablePrimary ? onClickPrimary : undefined}
            className={cx(styles.button, {
              [styles.buttonDisabled]: disablePrimary,
            })}
          >
            {primaryActionText}
          </div>
        </div>
      </div>
    </GenericPopup>
  );
};

export default Dialog;
